function BookmarkIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="#4079F5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M13.571 4H6.43c-.786 0-1.422.6-1.422 1.333L5 16l5-2 5 2V5.333C15 4.6 14.357 4 13.571 4z" />{' '}
    </svg>
  )
}

export default BookmarkIcon
